export interface ExternalTransferPhoneNumberDigitLimits {
  readonly minDigits: number
  readonly maxDigits: number
}

export const DEFAULT_EXTERNAL_TRANSFER_PHONE_NUMBER_DIGIT_LIMITS: ExternalTransferPhoneNumberDigitLimits =
  {
    minDigits: 10,
    maxDigits: 11,
  }

export const UK_EXTERNAL_TRANSFER_PHONE_NUMBER_DIGIT_LIMITS: ExternalTransferPhoneNumberDigitLimits =
  {
    minDigits: 10,
    maxDigits: 15,
  }

export const getExternalTransferPhoneNumberDigitLimits = (
  apiEnvironment?: string,
): ExternalTransferPhoneNumberDigitLimits =>
  apiEnvironment === 'production_uk'
    ? UK_EXTERNAL_TRANSFER_PHONE_NUMBER_DIGIT_LIMITS
    : DEFAULT_EXTERNAL_TRANSFER_PHONE_NUMBER_DIGIT_LIMITS

export const getPhoneNumberDigits = (value: unknown): string =>
  String(value ?? '').replace(/\D/g, '')

export const normalizeExternalTransferPhoneNumber = (
  value: unknown,
): string => {
  const phoneNumber = String(value ?? '').trim()
  const digits = getPhoneNumberDigits(phoneNumber)

  return phoneNumber.startsWith('+') ? `+${digits}` : digits
}

export const isValidExternalTransferPhoneNumber = (
  value: unknown,
  digitLimits: ExternalTransferPhoneNumberDigitLimits = DEFAULT_EXTERNAL_TRANSFER_PHONE_NUMBER_DIGIT_LIMITS,
): boolean => {
  const digitCount = getPhoneNumberDigits(value).length

  return (
    digitCount >= digitLimits.minDigits && digitCount <= digitLimits.maxDigits
  )
}
